export default __webpack_public_path__ + "static/media/285.f8601db6.png";